(() => {
  const BV_SELECTOR = '[data-bv-show]'
  const STYLE_ID = 'jpms-bazaarvoice-overrides'

  const styles = `
    :host {
      padding-right: 20px;
      padding-left: 20px;
    }
    :host .gYyWGA {
      padding-right: 0;
      padding-left: 0;
    }
    :host .gztyek,
    :host .goTcGM,
    :host #bv_review_filter_container,
    :host .jOthGt,
    :host .bvOrQm {
      margin-right: 0;
      margin-left: 0;
    }
    :host h2 {
      font-size: 38px;
      text-transform: uppercase;
    }
    @media (min-width: 1024px) {
      :host {
        padding-right: 45px;
        padding-left: 45px;
      }
      :host h2 {
        font-size: 48px;
      }
    }
  `

  const supportedModules = ['questions', 'reviews']

  const injectStyles = (host) => {
    const shadowRoot = host.shadowRoot
    const moduleType = host.dataset.bvShow

    if (!shadowRoot) return
    if (!supportedModules.includes(moduleType)) return
    if (shadowRoot.getElementById(STYLE_ID)) return

    const style = document.createElement('style')
    style.id = STYLE_ID
    style.textContent = styles

    shadowRoot.appendChild(style)
  }

  const initializeBazaarvoiceStyles = () => {
    document.querySelectorAll(BV_SELECTOR).forEach(injectStyles)
  }

  // Handle anything already initialized
  initializeBazaarvoiceStyles()

  // Watch for Bazaarvoice blocks being initialized
  const observer = new MutationObserver(() => {
    initializeBazaarvoiceStyles()
  })

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['data-bv-ready'],
  })
})()